import {DirectedAcyclicGraph} from "@/Core/Dag";
import {
    PlayableAudio,
    SlideData,
    SlideMetadata
} from "@/Core/SlideshowData";
import {AskQuestion} from "@/Core/Interactions";
import {injectable} from "inversify";

export interface ISlideshowBuilder {
    build(): Promise<SlideshowInformation>;
    getContent(id: string): Promise<SlideData>;
}

export interface SlideshowInformation {
    graph: DirectedAcyclicGraph<string>;
    slides: SlideMetadata[];
    audio: PlayableAudio[];
    supplierText: string|null;
    supportedLanguageCodes: string[];
    title: string;
    questions: AskQuestion[];
    css: string;
}

@injectable()
export class StandardSlideshowBuilder implements ISlideshowBuilder {
    private data: PlaybackData;

    async build(): Promise<SlideshowInformation> {
        let response = await fetch("playback-data.json");
        let playbackData = <PlaybackData> await response.json();
        this.data = playbackData;
        return playbackData.metadata;
    }

    getContent(id: string): Promise<SlideData> {
        let slide = this.data.slides.get(id);
        if (slide == null)
            throw "Slide not found";
        return Promise.resolve(slide);
    }

}

interface PlaybackData {
    metadata: SlideshowInformation;
    slides: Map<string, SlideData>;
}